export const BUDGETS_GENERIC_IDS = {
    BUDGETS_APP:    "BUDGETS_APP",

    CLIENTS:        "CLIENTS",
    PRODUCTS:       "PRODUCTS",
    ENTRIES:        "ENTRIES",
    BUDGETS:        "BUDGETS",
    DISTRIBUTORS:   "DISTRIBUTORS",
    LICENSES:       "LICENSES",
    LICENSE_TYPES:  "LICENSE_TYPES",

    BUDGETS_ENABLED_MODULES:    "BUDGETS_ENABLED_MODULES",
};